/**
 * single recipe js
 * handles behavior and note saving funcitonality for single recipe post
 *
 */
(function ($) {
    SoyVay.singleRecipe = (function () {
        function privateInit() {
            // detect if iphone or ipad
            if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i)) {
                $('body').addClass('iphone-ipad');
            }

            // set up print and share buttons
            document.querySelector('.pw-button-print').addEventListener('click', () => {
                window.print();
            });

            document.querySelector('.pw-button-pinterest').addEventListener('click', () => {
                const pinterestImage = document.querySelector('.pw-button-pinterest').dataset.image;
                window.social.newWindow(
                    `http://pinterest.com/pin/create/button/?url=${encodeURIComponent(document.URL)}&media=${pinterestImage}&description=${encodeURIComponent(document.title)}`
                );
            });

            document.querySelector('.pw-button-facebook').addEventListener('click', () => {
                window.social.newWindow(
                    `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(document.URL)}&quote=${encodeURIComponent(document.URL)}`
                );
            });

            document.querySelector('.pw-button-x').addEventListener('click', () => {
                window.social.newWindow(
                    `https://x.com/intent/tweet?text=${encodeURIComponent(document.title)}:%20${encodeURIComponent(document.URL)}`
                );
            });

            $('.db-scroll-link').click(function (e) {
                e.preventDefault();
                const targetId = $(this).attr('href');
                const scrollTo = $(targetId).offset().top - 185;
                $('.db-scroll-link').find('.circle').removeClass('circle-active');
                $(this).find('.circle').addClass('circle-active');
                $('html,body').animate(
                    {
                        scrollTop: scrollTo,
                    },
                    500
                );
            });

            const $noteForm = $('#recipe-note-form');
            const $postID = `recipe-${$noteForm.find('[name=post_id]').val()}`;
            let notesArray;

            // check Local Storage for previously saved notes
            const recipeStorage = localStorage.getItem('recipeNotes');
            notesArray = recipeStorage ? JSON.parse(recipeStorage) : {};
            if (notesArray[$postID]) {
                $noteForm.find('[name=note_content]').attr('data-last-saved', notesArray[$postID]);
                var entityMap = {
                    '&': '&amp;',
                    '<': '&lt;',
                    '>': '&gt;',
                    '"': '&quot;',
                    "'": '&#39;',
                    '/': '&#x2F;',
                    '`': '&#x60;',
                    '=': '&#x3D;'
                };
                var sanitizedNote = String(notesArray[$postID]).replace(/[&<>"'`=\/]/g, function (s) { return entityMap[s];});
                $noteForm.find('[name=note_content]').html(sanitizedNote);
            }

            //  Character Count removed as a requirement
            /*
            // Show remaining characters available for user notes.
            // The maximum length is set via the textarea's maxlength attribute.
            var updateCharacterCount = function() {
                var maxLength = $noteForm.find('[name=note_content]').attr('maxlength');
                var currentLength = $noteForm.find('[name=note_content]').val().length;
                var charsRemaining = maxLength - currentLength;
                $noteForm.find('.note-character-count span').text(charsRemaining);

                if(charsRemaining <= 10) {
                    $noteForm.find('.note-character-count').addClass('near-limit');
                } else {
                    $noteForm.find('.note-character-count').removeClass('near-limit');
                }
            }
            */

            const updateNoteUI = function () {
                if (
                    $noteForm.find('[name=note_content]').attr('data-last-saved') !==
                    $noteForm.find('[name=note_content]').val()
                ) {
                    $noteForm.find('[type=submit]').attr('disabled', false);
                } else {
                    $noteForm.find('[type=submit]').attr('disabled', true);
                }
                //  Character Count removed as a requirement
                //  updateCharacterCount();
            };

            //  Character Count removed as a requirement
            // Populate remaining character count on page load
            // updateCharacterCount();

            // update note UI to start with disabled state
            updateNoteUI();

            // Cache note contents on page load to
            // decide if a save affordance should be
            // shown to the user when content has changed.
            $noteForm.find('[name=note_content]').on('input paste', (e) => {
                updateNoteUI();
            });

            $noteForm.find('[name=note_content]').on('focus', (e) => {
                //  Character Count removed as a requirement
                //  $noteForm.find('.note-character-count').removeClass('hidden');
                $('.js-edit-notes').addClass('hidden');
            });

            $('.js-edit-notes').on('click', function (e) {
                e.preventDefault();
                $(this).addClass('hidden');
                $noteForm.find('[name=note_content]').focus();
                //  Character Count removed as a requirement
                //  $noteForm.find('.note-character-count').removeClass('hidden');
            });

            // Handle saving a recipe note
            $noteForm.submit((e) => {
                e.preventDefault();
                if (window.OptanonActiveGroups && window.OptanonActiveGroups.indexOf('C0003') >= 0) {
                    const lastSaved = $noteForm.find('[name=note_content]').val();
                    $noteForm.find('[name=note_content]').attr('data-last-saved', lastSaved);
                    notesArray[$postID] = lastSaved;
                    localStorage.setItem('recipeNotes', JSON.stringify(notesArray));
                    $('.note-saved-message').html('Your note has been saved');
                    $('#recipe-note-form textarea').css('border', 'none');
                    setTimeout(() => {
                        $('.note-saved-message').html('');
                    }, 3000);
                    $noteForm.garlic('destroy');
                    updateNoteUI();
                } else {
                    $('.note-saved-message').html('Your note could not be saved');
                }
            });

            // Swap the tip icon with the video icon when it flashes
            const $tipImage = $('.toggle-video img');
            if (typeof $tipImage.attr('src') !== 'undefined') {
                const tipImgSrc = $tipImage.attr('src');
                const vidImgSrc = tipImgSrc.replace('tipicon.svg', 'img/global/vidicon.png');
                let isVidIcon = false;

                setInterval(() => {
                    isVidIcon = !isVidIcon;
                    if (isVidIcon) {
                        $tipImage.attr('src', vidImgSrc);
                    } else {
                        $tipImage.attr('src', tipImgSrc);
                    }
                }, 2000);
            }
        }
        return {
            init() {
                privateInit();
            },
        };
    })();

    // document ready
    $(document).ready(() => {
        SoyVay.singleRecipe.init();
    });
})(jQuery);
